/** Translation key of the title shown in the top bar for a route. Longest matching prefix wins. */
const TITLES: [string, string][] = [
  ["/ai/analyses", "aces.nav.analyses"],
  ["/ai/analysis", "aces.titles.analysis"],
  ["/ai/findings", "aces.nav.findings"],
  ["/ai/finding", "aces.titles.finding"],
  ["/submittedChecklist", "aces.nav.reports"],
  ["/newchecklist", "aces.nav.checklists"],
  ["/checklist", "aces.nav.checklists"],
  ["/templatelist", "aces.nav.templates"],
  ["/capa", "aces.nav.capa"],
  ["/chat", "aces.nav.teamChat"],
  ["/notification", "aces.nav.notifications"],
  ["/usermanagment", "aces.nav.users"],
  ["/settings/sites", "aces.nav.sites"],
  ["/audit", "aces.nav.audit"],
  ["/admin/ai-settings", "aces.nav.aiSettings"],
  ["/admin/standards", "aces.nav.catalogue"],
  ["/profile", "aces.nav.profile"],
  ["/billing", "aces.nav.billing"],
  ["/paymentinquiry", "aces.nav.payments"],
];

export const pageTitleKey = (pathname: string): string =>
  TITLES.find(([path]) => pathname === path || pathname.startsWith(`${path}/`))?.[1] ?? "aces.nav.home";
